import {
  FETCH_ROUTES_REQUEST,
  FETCH_ROUTES_SUCCESS,
  FETCH_ROUTES_FAILURE,
  CLEAR_ROUTES,
} from '../constants';

const initialState = {
  data: [],
  error: false,
  fetching: false,
};

const routesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ROUTES_REQUEST:
      return {
        ...initialState,
        error: false,
        fetching: true,
      };
    case FETCH_ROUTES_SUCCESS:
      return {
        data: action.payload,
        error: false,
        fetching: false,
      };
    case FETCH_ROUTES_FAILURE:
      return {
        data: [],
        error: action.payload,
        fetching: false,
      };
    case CLEAR_ROUTES:
      return {
        data: [],
        error: false,
        fetching: false,
      };
    default:
      return state;
  }
};

export default routesReducer;
